import React, { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import {
  Layout,
  Typography,
  Card,
  Form,
  Input,
  Row,
  Col,
  Checkbox,
  Spin,
} from "antd";
import { useNavigate } from "react-router-dom";

// PROJECT IMPORTS
import "../../../assets/styles/DatePicker.css";
import MainLayout from "../../../components/layouts/MainLayout";
import CustomButton from "../../../components/custom/CustomButton";
import TopContent from "../../../components/layouts/TopContent";
import appStatic from "../../../config/appStatic";
import appLabel from "../../../config/appLabel";
import { BOM } from "../../../services/definedMethod";
import { apiConfig, staticConfig } from "../systemAdmin.config";
import cnt from "../../../services/definedConstant";

const { Text, Title } = Typography;

const EditEmailService = (props) => {
  const { userData } = props;
  const { session } = userData;

  const [isLoading, setIsLoading] = useState(false);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    getEmailServiceConfig();
  }, []);

  /** ---------------------------
   * GET EMAIL CONFIGURATION
   * -------------------------- */
  const getEmailServiceConfig = () => {
    setIsLoading(true);

    const url = `${apiConfig.ExternalServiceEmail}/SMTP`;
    const body = { session };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors?.[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        const formatted = (res || []).reduce((acc, item) => {
          acc[item.name] = item.value;
          return acc;
        }, {});

        form.setFieldsValue({
          host: formatted.host,
          port: formatted.port,
          useTLS: formatted.useTLS === "true",
          fromName: formatted.fromName,
          username: formatted.username,
          password: formatted.password,
          fromEmail: formatted.fromEmail,
        });

        setIsLoading(false);
      }
    });
  };

  /** ---------------------------
   * SUBMIT UPDATED CONFIGURATION
   * -------------------------- */
  const onFinish = (values) => {
    setIsLoading(true);

    const payload = {
      fromEmail: values.fromEmail,
      fromName: values.fromName,
      host: values.host,
      password: values.password,
      port: values.port,
      useTLS: values.useTLS ? "true" : "false",
      username: values.username,
    };

    console.log(values);
    console.log(payload);

    const url = `${apiConfig.ExternalServiceEmail}/SMTP`;
    const body = {
      session,
      ...payload,
      method: "PUT",
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      setIsLoading(false);

      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors?.[0]?.defaultUserMessage);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, "Email configuration updated successfully.");
        navigate("/sya2700");
      }
    });
  };

  const onCancel = () => {
    navigate("/sya2700");
  };

  return (
    <MainLayout isEnableRightSidebar={true}>
      <TopContent
        pageTitle={"Edit Email Service Configuration"}
        pageItems={staticConfig.editExternalNotifcationEmailBreadcrumbItems}
      />

      <Spin spinning={isLoading} size="large">
        <Card
          title={
            <Title level={4} style={{ color: "#000" }}>
              {appLabel.generalInfo}
            </Title>
          }
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Form
            form={form}
            layout="vertical"
            requiredMark={false}
          >
            <Card
              style={{
                marginBottom: "3%",
                boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
              }}
              bordered
            >
              <Row gutter={[16, 16]}>
                <Col span={12}>
                  <Form.Item
                    name="host"
                    label={<Text strong>Host</Text>}
                    rules={[{ required: true, message: "Host is required" }]}
                  >
                    <Input placeholder="SMTP Host" />
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Form.Item
                    name="port"
                    label={<Text strong>Port</Text>}
                    rules={[{ required: true, message: "Port is required" }]}
                  >
                    <Input placeholder="Port Number" />
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Form.Item
                    name="useTLS"
                    valuePropName="checked"
                    label={<Text strong>Use TLS</Text>}
                  >
                    <Checkbox>Enable TLS</Checkbox>
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Form.Item
                    name="fromName"
                    label={<Text strong>From Name</Text>}
                    rules={[
                      { required: true, message: "From Name is required" },
                    ]}
                  >
                    <Input placeholder="From Name" />
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Form.Item
                    name="username"
                    label={<Text strong>Username</Text>}
                    rules={[
                      { required: true, message: "Username is required" },
                    ]}
                  >
                    <Input placeholder="Username" />
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Form.Item
                    name="password"
                    label={<Text strong>Password</Text>}
                    rules={[
                      { required: true, message: "Password is required" },
                    ]}
                  >
                    <Input.Password placeholder="Password" />
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Form.Item
                    name="fromEmail"
                    label={<Text strong>From Email</Text>}
                    rules={[
                      { required: true, message: "From Email is required" },
                    ]}
                  >
                    <Input placeholder="From Email" />
                  </Form.Item>
                </Col>
              </Row>
            </Card>

            <Form.Item>
              <Row justify="end" gutter={16}>
                <Col>
                  <CustomButton
                    content="Cancel"
                    style={{
                      width: 120,
                      boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                    }}
                    backgroundColor="#fff"
                    colorText="black"
                    hoverBackground="#F5F5F5"
                    onClick={onCancel}
                  />
                </Col>
                <Col>
                  <CustomButton
                    content="Save Changes"
                    style={{
                      width: 160,
                      boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                    }}
                    backgroundColor="#1677ff"
                    colorText="#fff"
                    hoverBackground="#4096ff"
                    onClick={() => {
                      form
                        .validateFields()
                        .then((values) => {
                          onFinish(values);
                        })
                        .catch((errorInfo) => {
                          console.log("❌ Validation failed:", errorInfo);
                        });
                    }}
                  />
                </Col>
              </Row>
            </Form.Item>
          </Form>
        </Card>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
});

export default connect(mapStateToProps)(EditEmailService);
